import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'crop-modal',
    templateUrl: 'crop-modal.html'
})
export class CropModalComponent {

    @Input()
    imageChangedEvent: any = '';

    @Input()
    croppedImage: any = '';

    @Output()
    savedImage = new EventEmitter();

    @Output()
    closedDialog = new EventEmitter();

    constructor() {
    }

    onSaveImage() {
        this.savedImage.emit();
    }

    onImageCropped(image: string) {
        this.croppedImage = image;
    }

    onDialogClosed() {
        this.closedDialog.emit();
    }

}



// WEBPACK FOOTER //
// ./src/components/crop-modal/crop-modal.ts